module.exports = __webpack_public_path__ + "img/PortVilaMap-dark.58d14bd8.jpg";